module.exports = __webpack_public_path__ + "static/media/goto.85900a19.svg";